import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import UIKit from 'uikit'
import 'uikit/dist/css/uikit.min.css'
Vue.prototype.$uikit = UIKit

new Vue({
  render: h => h(App),
}).$mount('#app')
